import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "jasbwg jtbwg"
};
const _hoisted_2 = {
  class: "wapbanner"
};
const _hoisted_3 = {
  id: "banner",
  class: "swiper-container",
  ref: "swiperBanner"
};
const _hoisted_4 = {
  class: "swiper-wrapper"
};
const _hoisted_5 = {
  class: "swiper-slide"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "wapnav"
};
const _hoisted_8 = {
  class: "swiper-container swiper1",
  ref: "swiper1"
};
const _hoisted_9 = {
  class: "swiper-wrapper"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "wapbox wapbox1"
};
const _hoisted_13 = {
  class: "waptitlebox title1"
};
const _hoisted_14 = {
  class: "swiper-container swiper3",
  ref: "swiper3"
};
const _hoisted_15 = {
  class: "swiper-wrapper"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "wapbox"
};
const _hoisted_19 = {
  class: "waptitlebox title2"
};
const _hoisted_20 = {
  class: "wapnewli"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "wapbox"
};
const _hoisted_23 = {
  class: "waptitlebox title3"
};
const _hoisted_24 = {
  class: "swiper-container swiper2",
  ref: "swiper2"
};
const _hoisted_25 = {
  class: "swiper-wrapper"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["src", "alt"];
const _hoisted_28 = {
  class: "wapbox"
};
const _hoisted_29 = {
  class: "waptitlebox title4"
};
const _hoisted_30 = {
  class: "swiper-container swiper4",
  ref: "swiper4"
};
const _hoisted_31 = {
  class: "swiper-wrapper"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["src", "alt"];
const _hoisted_34 = {
  class: "wapbox server"
};
const _hoisted_35 = {
  class: "wapspecialbox"
};
const _hoisted_36 = {
  class: "wapspecialli"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.banners, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_6)]);
  }), 256))]), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "pagination"
  }, null, -1))], 512)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, n => {
    return _createElementVNode("div", {
      class: "swiper-slide",
      onClick: $event => $options.clickTab(n)
    }, [_createElementVNode("a", null, [_createElementVNode("img", {
      src: require(`../../assets/bwg/2-${n - 1}.png`),
      alt: ""
    }, null, 8, _hoisted_11)])], 8, _hoisted_10);
  }), 64))])], 512)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[5] || (_cache[5] = _createElementVNode("h2", null, null, -1)), _createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = $event => $options.toDetail(2078673, '金博展览', 6235111, 412309, true))
  })]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.exhibitions.filter((c, ci) => {
    return ci < 5;
  }), (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      onClick: $event => $options.openDetail(6235111, index, 2078673, 412309)
    }, [_createElementVNode("a", null, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_17), _createElementVNode("div", null, _toDisplayString(item.name), 1)])], 8, _hoisted_16);
  }), 256))])], 512)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_cache[6] || (_cache[6] = _createElementVNode("h2", null, null, -1)), _createElementVNode("a", {
    onClick: _cache[1] || (_cache[1] = $event => $options.toDetail(2081929, '新闻动态', 6235070, 412309))
  })]), _createElementVNode("ul", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.news.filter((n, ni) => {
    return ni < 3;
  }), (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      onClick: $event => $options.openDetail('', index, 2081929, 412309)
    }, [_createElementVNode("a", null, [_createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("span", null, _toDisplayString(item.time ? item.time.split(' ')[0] : ''), 1)])], 8, _hoisted_21);
  }), 256))])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[7] || (_cache[7] = _createElementVNode("h2", null, null, -1)), _cache[8] || (_cache[8] = _createElementVNode("span", {
    class: "line"
  }, null, -1)), _createElementVNode("a", {
    onClick: _cache[2] || (_cache[2] = $event => $options.toDetail(2078670, '馆藏文物', 6235182, 412309))
  })]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.collections.filter((c, ci) => {
    return ci < 5;
  }), (item, index) => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      onClick: $event => $options.openDetail('', index, 2078670, 412309)
    }, [_createElementVNode("a", null, [_createElementVNode("img", {
      src: item.img,
      alt: item.name
    }, null, 8, _hoisted_27), _createElementVNode("span", null, _toDisplayString(item.name), 1)])], 8, _hoisted_26)), [[_vShow, index]]);
  }), 256))])], 512)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_cache[9] || (_cache[9] = _createElementVNode("h2", null, null, -1)), _createElementVNode("a", {
    onClick: _cache[3] || (_cache[3] = $event => $options.toDetail(2081849, '馆内活动', 6235164, 412309))
  })]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.activitys.filter((c, ci) => {
    return ci < 4;
  }), (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      onClick: $event => $options.openDetail('', index, 2081849, 412309)
    }, [_createElementVNode("a", null, [_createElementVNode("img", {
      src: item.img,
      alt: item.name
    }, null, 8, _hoisted_33), _createElementVNode("div", null, _toDisplayString(item.name), 1)])], 8, _hoisted_32);
  }), 256))])], 512)]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("ul", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.server.filter(s => {
    return s.name != '参观预约';
  }), (item, index) => {
    return _openBlock(), _createElementBlock("li", null, [_createElementVNode("a", {
      onClick: $event => $options.openUrl(item.url)
    }, [_createElementVNode("img", {
      src: require(`../../assets/bwg/block${index + 1}.png`)
    }, null, 8, _hoisted_38)], 8, _hoisted_37)]);
  }), 256))])])]), _cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "wapunder"
  }, [_createElementVNode("i"), _createElementVNode("span", null, "我是有底线的"), _createElementVNode("i")], -1))]);
}